/**
 * Plot notebook turn helpers. Writer-facing copy.
 * Bring a turn and Confirm stay on the notebook.
 * They do not write a long plot.
 */

export const LOGLINE_EMPTY = "This book doesn't have a Logline yet.";

export const TURN_PENDING = 'Not confirmed yet';

export const CONFIRM_TURN = 'Confirm';

export const PENDING_TURNS_WHY = 'These turns are not confirmed yet.';

export const BRING_A_TURN = 'Bring a turn here';

export const BRING_A_TURN_WHY =
  'Click Bring a turn here and choose a line from the chat. '
  + 'It stays not confirmed until you Confirm.';

export const BRING_TURN_EMPTY =
  'Nothing unused in this chat to bring here yet. '
  + 'A turn is your own line from Discovery, Explore, or Focus '
  + 'that is not already on the plot. '
  + 'Write one in that chat, then come back.';

export function bringTurnEmptyWhy(view) {
  const why = String((view && view.unused_chat_why) || '').trim();
  return why || BRING_TURN_EMPTY;
}

export const CHOOSE_A_CHAT_LINE = 'Choose a line from the chat.';

export const PROPOSE_TURNS = 'Generate';

export const REGENERATE_ALL_TURNS = 'Regenerate all';

export function writerFacingError(message) {
  const raw = String(message || '').trim();
  const stripped = raw.replace(/^VALIDATION:\s*[^-]+-\s*/, '').trim();
  return stripped || 'Could not bring a turn here.';
}

export function liftedLogline(view) {
  const text = String((view && view.logline) || '').trim();
  return text || null;
}

export function unusedChatLines(view) {
  const rows = (view && view.unused_chat_lines) || [];
  return rows
    .map((row) => ({
      id: String((row && row.id) || '').trim(),
      content: String((row && row.content) || '').trim(),
    }))
    .filter((row) => row.id && row.content);
}
